// @ts-nocheck
import { parseMemorialDeepLinkParams } from "../features/memorial-deep-link";
import { getBrowserCookie } from "../utils/cookies";
import { getHeadstoneWorldPosition, getHoleWorldPosition } from "./holes";
import { boundsAroundPoint, type WorldBounds } from "./viewport-bounds";

function isStripeReturn(params: URLSearchParams): boolean {
  return !!(
    params.get("session_id") ||
    params.get("success") === "true" ||
    params.get("canceled") === "true"
  );
}

export function resolveInitialBootBounds(): WorldBounds | null {
  const params = new URLSearchParams(window.location.search);

  if (isStripeReturn(params)) {
    const pendingHoleId = getBrowserCookie("pendingHoleId");
    if (pendingHoleId) {
      const pos = getHoleWorldPosition(pendingHoleId);
      if (pos) return boundsAroundPoint(pos.x, pos.y);
    }
    return null;
  }

  const target = parseMemorialDeepLinkParams(params);
  if (!target) return null;

  if (target.x !== undefined && target.y !== undefined) {
    const { x, y } = getHeadstoneWorldPosition(target.x, target.y);
    return boundsAroundPoint(x, y);
  }

  if (target.holeId) {
    const pos = getHoleWorldPosition(target.holeId);
    if (pos) return boundsAroundPoint(pos.x, pos.y);
  }

  return null;
}
